<template>
  <div class="leftnavmain">
    <div class="portrait">
      <div class="demo-avatar-badge portraitimg">
        <Badge>
          <Avatar v-if="userAcatar" size="large" shape="square" icon="ios-person" :src="userAcatar"/>
          <Avatar v-else size="large" shape="square" icon="ios-person"/>
        </Badge>
      </div>
      <h4 class="username">{{showName}}</h4>
    </div>
    <Menu :theme="theme3" active-name="1" @on-select="navigateTo">
      <MenuGroup>
        <MenuItem v-for="item in menuList" :key="`menu_${item.name}`" :name="item.name">
          <Icon :type="item.icon"/>
          {{item.title}}
        </MenuItem>
      </MenuGroup>
    </Menu>
  </div>
</template>
<script>
export default {
  name: "leftnav",
  data() {
    return {
      theme3: "light",
      menuList: [
        // {
        //   title: "专家审核",
        //   name: "/Expertreview",
        //   icon: "md-compass"
        // },
      ],
      userInfo: {},
      showName: "",
      userAcatar: ""
    };
  },
  mounted() {
    var that = this;
    that.userInfo = that.$store.state.userInfo;
    if (!that.userInfo) {
      that.userInfo = that.$localstorage.fetch("userInfo");
      if (!that.userInfo || !that.userInfo.userName) {
        that.$Message.info("未登陆或登陆信息已过期，请登陆");
        that.$router.push({ name: "login" });
      }
    }
    that.showName = that.userInfo.realName
      ? that.userInfo.realName
      : that.userInfo.userName;
    if (that.userInfo.roleId == window.RoleType.Admin) {
      that.menuList = [
        {
          title: "专家库",
          name: "/ExpertDatabase",
          icon: "md-document"
        },
        // {
        //   title: "题库管理",
        //   name: "/testmanagement",
        //   icon: "md-chatbubbles"
        // },
        {
          title: "任务管理",
          name: "/taskmanagement",
          icon: "md-help-buoy"
        },
        {
          title: "细目表管理",
          name: "/structureManage",
          icon: "md-list"
        },
        // {
        //   title: "省账号管理",
        //   name: "/ProvinceUser",
        //   icon: "md-person"
        // }
      ];
    } else if (that.userInfo.roleId == window.RoleType.Proposition) {
      that.menuList = [
        {
          title: "我的任务",
          name: "/Mytasks",
          icon: "md-cube"
        },
        {
          title: "审核状态",
          name: "/Trytoreview",
          icon: "ios-create"
        }
      ];
    } else if (that.userInfo.roleId == window.RoleType.FirstTrial) {
      that.menuList = [
        {
          title: "我的任务",
          name: "/Mytasks",
          icon: "md-cube"
        },
        // {
        //   title: "审核状态",
        //   name: "/Trytoreview",
        //   icon: "ios-create"
        // },
        {
          title: "我的任务-初审",
          name: "/Mytasks_trial",
          icon: "md-cube"
        }
      ];
    } else if (that.userInfo.roleId == window.RoleType.Review) {
      that.menuList = [
        {
          title: "我的任务",
          name: "/Mytasks",
          icon: "md-cube"
        },
        // {
        //   title: "审核状态",
        //   name: "/Trytoreview",
        //   icon: "ios-create"
        // },
        {
          title: "我的任务-初审",
          name: "/Mytasks_trial",
          icon: "md-cube"
        },
        {
          title: "我的任务-复审",
          name: "/Mytasks_review",
          icon: "md-cube"
        }
      ];
    }else if (that.userInfo.roleId == window.RoleType.ProvinceAdmin) {
      that.menuList = [
        // {
        //   title: "题库管理",
        //   name: "/ProvinceQuestions",
        //   icon: "md-chatbubbles"
        // },
        {
          title: "细目表管理",
          name: "/ProvinceStructureManage",
          icon: "md-list"
        }
      ];
    }
    if(that.userInfo.avatar){
      that.userAcatar=that.$config.baseUrl.dev+that.userInfo.avatar;
    }
  },
  methods: {
    navigateTo(name) {
      this.$router.push(name);
    }
  }
};
</script>
<style scoped>
.ivu-menu {
  width: 230px !important;
}
.leftnavmain {
  position: relative;
}
.portrait {
  height: 50px;
  position: absolute;
  top: 30px;
  left: 25px;
  z-index: 999;
}
.portraitimg {
  float: left;
  z-index: 999;
}
.username {
  width: 120px;
  float: left;
  padding-left: 15px;
  line-height: 40px;
  font-size: 15px;
}
.ivu-menu-item:first-child {
  margin-top: 40px;
}
.ivu-menu-vertical.ivu-menu-light:after {
  background-color: white;
}
.ivu-badge-dot {
  background: #19be6b;
}
</style>





// WEBPACK FOOTER //
// src/components/leftNav/leftnav.vue